<template lang="html">
    <div class="card card-statistics">
        <div class="card-body">
            <div class="clearfix">
                <div class="float-left">
                    <i class="mdi mdi-cube text-danger icon-lg"></i>
                </div>
                <div class="float-right">
                    <p class="mb-0 text-right">Total Revenue</p>
                    <div class="fluid-container">
                        <h3 class="font-weight-medium text-right mb-0"> {{ totalRevenue }} kr</h3>
                    </div>
                </div>
            </div>
            <p class="text-muted mt-3 mb-0">
              <i class="mdi mdi-alert-octagon mr-1" aria-hidden="true"></i> 
              Last week: $35,650
            </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from'vuex'
export default {
  name: 'totalrevenuecard',
  computed : {
      ...mapGetters({
          totalRevenue : 'ordermessages/totalRevenue'
      })
  }
}
</script>